import { Injectable } from "@angular/core";
import { DateRangeParam, UserPreference } from "../../models";
import { appSettings, errorMessages } from "../../settings";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";
import { MHENoReadData, WidgetParam } from "../../models/DataModels";

@Injectable()
export class MheNoReadDataService extends BaseService {
  defaultSummaryType: string = "D";
  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService
  ) {
    super();
  }

  init(widget: any) {
    let self = this;
    widget.dataLoaded = false;
    let param = new WidgetParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    if(setting.PickType == 'PostShip' || setting.PickType == null || setting.PickType == '') {
      setting.PickType = appSettings.Last2Weeks;
    }
    if(setting.Criteria == null || JSON.parse(setting.Criteria).SummaryType == null) {
      var criteria = JSON.parse(setting.Criteria)? JSON.parse(setting.Criteria) : {};
      criteria.SummaryType = self.defaultSummaryType;
      setting.Criteria = JSON.stringify(criteria);
    }
    
    dateParam.RangeValue = this._widgetHelper.GetSummaryType(setting.PickType);
    dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(setting.PickType);

    this._analyticsService.getDates(dateParam).subscribe(data => {
      if (
        data.Start_Date.toString() != "0001-01-01T00:00:00" &&
        data.End_Date.toString() != "0001-01-01T23:59:59.999"
      ) {
        param.StartDate = new Date(data.Start_Date);
        param.EndDate = new Date(data.End_Date);
        let userPref: UserPreference = this._commonService.getUserPreference();
        param.CustomerId = userPref.CustomerId;
        param.FacilityId = userPref.FacilityId;
        param.SummaryType = setting.Criteria && JSON.parse(setting.Criteria).SummaryType ? JSON.parse(setting.Criteria).SummaryType : self.defaultSummaryType;
        
        this.GetMHENoReadDataSummary(widget, param);
      }
    });
  }

  GetMHENoReadDataSummary(widget, param: WidgetParam) {
    let userPref: UserPreference = this._commonService.getUserPreference();
    param.CustomerId = userPref.CustomerId;
    param.FacilityId = userPref.FacilityId;

    this._analyticsService.GetMHENoReadDataSummary(param).subscribe(
      (result: Array<MHENoReadData>) => {
        widget.errorMessage = null;
        if (result && result.length > 0) {
          let mheNoRead = [];
          let xAxisData = [];
          result.forEach(row => {
            let rptdate = null;
            if(param.SummaryType == 'D'){
              rptdate = this._commonService.formatDate(new Date(row.REPORT_DATE), appSettings.chartDayFormat);
            }
            else if(param.SummaryType == 'W') {
              rptdate = this._commonService.formatDate(new Date(row.WEEK_START_DATE), appSettings.chartDayFormat);
            }
            else if(param.SummaryType == 'M') {
              rptdate = row.MONTH_ABBR_NAME + ' ' + row.YEAR_NUMBER;
            }
            else if(param.SummaryType == 'Q') {
              rptdate = 'QTR ' + row.QUARTER_NUMBER + ' ' + row.YEAR_NUMBER;
            }
            else if(param.SummaryType == 'Y') {
              rptdate = row.YEAR_NUMBER
            }
            if (rptdate && xAxisData.indexOf(rptdate) == -1) {
              mheNoRead.push(row.MHE_NO_READ_COUNT);    
              xAxisData.push(rptdate);
            }
          });

          widget.chartOptions = this.chartOptions();
          this.addDataSeries(widget.chartOptions, mheNoRead, "", "bar", "1");
          this.addZoomBar(widget.chartOptions);
          widget.chartOptions.xAxis.data = xAxisData;
          widget.chartOptions.xAxis.axisLabel.rotate = 45;
        } else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;
      },
      err => {
        console.log("GetMHENoReadDataSummary", err);
        widget.errorMessage = errorMessages.apiError;
        widget.dataLoaded = true;
      }
    );
  }

  reload(widget: any) {}

  remove(widget: any) {}

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/mhe-no-read-data.service.ts